import script from "./BottomMenuBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./BottomMenuBar.vue?vue&type=script&setup=true&lang=ts"

import "./BottomMenuBar.vue?vue&type=style&index=0&id=5e9cb467&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e9cb467"]])

export default __exports__